export default {
  logado:null,
}



// WEBPACK FOOTER //
// ./src/store/usuario/state.js